import Leaflet from './Leaflet';

class ServiceAreaLayer {
    constructor (currentMap) {
        return new Leaflet.GeoJSONLayer({
            map: currentMap,
            showAll: true,
            autofocus: false,
            uniqueField: 'radius',
            symbology: {
                type: 'uniq',
                property: 'radius',
                values: [{
                    value: 1,
                    style: {
                        fillColor: '#e74c3c',
                        fillOpacity: 0.3,
                        color: '#e74c3c',
                        opacity: 1,
                        weight: 2,
                        clickable: false
                    }
                }, {
                    value: 2,
                    style: {
                        fillColor: '#e67e22',
                        fillOpacity: 0.3,
                        color: '#e67e22',
                        opacity: 1,
                        weight: 2,
                        clickable: false
                    }
                }, {
                    value: 3,
                    style: {
                        fillColor: '#f1c40f',
                        fillOpacity: 0.3,
                        color: '#f1c40f',
                        opacity: 1,
                        weight: 2,
                        clickable: false
                    }
                }]
            }
        });
    }
}

export default ServiceAreaLayer;



// WEBPACK FOOTER //
// ./src/scripts/layers/ServiceAreaLayer.js